function runinlayPopup(){
if (window.location.pathname.includes("/products/") || !window.location.pathname.includes("/blogs")) {
     console.log("On a product page → script stopped.");
     return;
   }
   
     if ([
     "https://newzealandhoneyco.com/pages/manuka-honey-for-gut-health-h-pylori-gerd-reflux-gastritis-colitis",
     "https://newzealandhoneyco.com/pages/manuka-honey-for-immunity",
     "https://newzealandhoneyco.com/pages/manuka-honey-for-gut-health-h-pylori-gerd-reflux-gastritis-colitis#pylori",
     "https://newzealandhoneyco.com/pages/manuka-honey-for-immunity#cold-flu",
     "https://newzealandhoneyco.com/pages/manuka-honey-for-immunity#sore-throats"
   ].includes(window.location.href)) return;
   
   
     const span = document.querySelector(
       ".shg-rich-text.shg-theme-text-content span"
     );
     const text = span ? span.textContent.trim() : "";
   
     if (text.includes("CUSTOMER STORY")) {
       console.log("Customer Story page detected → script stopped.");
       // 2) Add your CSS rule (including !important)
   //       (() => {
   //   // Only apply when viewport is ≥ 990px
   //   if (window.matchMedia("(min-width: 990px)").matches) {
   //     document.querySelectorAll(".page-width--narrow").forEach(el => {
   //       el.style.maxWidth = "100%";
   //       el.style.padding = "0";
   //     });
   //   }
   // })
   //     ();
   
       return;
     }
     console.log("🔔 NZ Honey script running on", window.location.pathname);
   
     const style = document.createElement("style");
   
     // 2) Add your CSS rule (including !important)
     style.textContent = `
        body .c-product__rating__star--custom svg {
         background-color: #333 !important;
       }

       body .nzhc_prodDetail .nzhc_stickyImg {
            background-color: #fff !important;
        }

        body .nzhc_prodDetail .nzhc_stickyImg img{
          background-color: #fff !important;
        }
   
       body .c-product__rating__stars .c-product__rating__star--custom {
        background-color: #333 !important;
    }

      body .nzhc_review .c-product__rating__infos {
        background-color: #333 !important;
      }   

        .nzhc_stickyCTA,
            .nzhc_stickyWrapper {
            background-color: #333 !important;
        }

        .nzhc_stickyCTA a {
            background-color: #d6206c !important;
        }

        .c-product__rating__infos {
            background-color: #333 !important;
        }

        .nzhc_stickyImg img {
            background-color: #fff !important;
        }

        .nzhc_prodDetail,
        .nzhc_stickyDetail h6,
        .nzhc_review {
        background-color: #333 !important;
        }

        html.nzHoney_blackout,
        html.nzHoney_blackout *,
        body.nzHoney_blackout,
        body.nzHoney_blackout * {
        background-color: #b6b2b2a6 !important;
        }

        .nzHoney_overlaysPopup + .klaviyo-form {
        display: none;
        }

        .nzHoney_overlaysPopup {
        position: relative;
        width: 100%;
        overflow: hidden;
        }

        .nzHoney_overlaysPopup img {
        width: 100%;
        height: 100%;
        }

        .nzHoney_overlaysPopup .mobileImage {
        display: none;
        }

        .nzHoney_overlaysPopup .desktopImage {
        display: block;
        }


        body .nzhc_stickyWrapper{
            background-color: #333 !important;
        }

        body  .nzhc_stickyCTA{
            background-color: #333 !important;
        }

        body .progress-bar-container{
            background-color: #f3f3f3 !important;
        }

        body .nzhc_prodDetail{
            background-color: #333 !important;
        }

        body .nzhc_stickyCTA a {
            background-color: #d6206c !important;
        }

        body .nzhc_review{
            background-color: #333 !important;
        }

        body .nzhc_stickyDetail h6 {
            background: #333 !important;
        }

        body .nzhc_stickyDetail {
            background: #333 !important;
        }

        body .product__rating__infos{
            background-color: #333 !important;
        }


        @media only screen and (max-width: 767px) {
        .nzHoney_overlaysPopup .mobileImage {
            display: block;
        }
        .nzHoney_overlaysPopup .desktopImage {
            display: none;
        }

 
        .article-template__content {
            width: 100%;
            margin: 0 auto;
        }

        
        }

   `;
   
     // 3) Append it to <head>
     document.head.appendChild(style);
   
     // 2) Helper: poll for any elements matching "selector" up to timeout
     const waitForElements = (selector, timeout = 10000) =>
       new Promise((resolve, reject) => {
         const interval = 50;
         let elapsed = 0;
         const iv = setInterval(() => {
           const found = Array.from(document.querySelectorAll(selector));
           if (found.length) {
             clearInterval(iv);
             resolve(found);
           } else if (elapsed >= timeout) {
             clearInterval(iv);
             reject(new Error(`Timeout waiting for "${selector}"`));
           }
           elapsed += interval;
         }, interval);
       });
   
     // 3) Delay helper (just a wrapper around setTimeout)
     const delay = (ms) => new Promise((r) => setTimeout(r, ms));
   
     // 4) Main popup logic
     const initPopup = async () => {
       try {
         // a) Wait for Shogun “image containers” so we can hide those boxes
         console.log("⏳ NZ Honey: waiting for Shogun containers…");
         const targetElems = await waitForElements(
           ".shogun-image-container:not([data-animations]), .shg-product-image-wrapper",
           10000
         );
         console.log(
           "✅ NZ Honey: found",
           targetElems.length,
           "Shogun containers"
         );
   
         // b) Hide each matching box (unless nested under .stacked)
         targetElems.forEach((el) => {
           if (el.closest(".stacked")) return;
           const box = el.closest(".shg-box");
           if (box) {
             box.classList.add("hideExisting_Honey");
             console.log("↳ NZ Honey: hiding box", box);
           }
         });
   
         // c) Give Klaviyo 2.5 seconds to finish injecting its form
         console.log("⏳ NZ Honey: waiting 2.5s for Klaviyo forms…");
         await delay(2500);
   
         // d) Grab all Klaviyo forms now in the DOM
         const forms = document.querySelectorAll(".klaviyo-form");
         console.log("🔍 NZ Honey: Klaviyo forms found:", forms.length);
         if (!forms.length) {
           console.warn("⚠ NZ Honey: no Klaviyo forms → aborting overlay");
           return;
         }
   
         // e) Target only the FIRST Klaviyo form
         const firstForm = forms[0];
         console.log("🎯 NZ Honey: targeting first Klaviyo form", firstForm);
   
         // f) Insert overlay directly before that form
         firstForm.insertAdjacentHTML(
           "beforeBegin",
           `<div class="nzHoney_overlaysPopup w3_bg">
                  <a href="/products/manuka-honey-umf-24-mgo-1122">
                    <img
                      class="mobileImage"
                      src="https://cdn.shopify.com/s/files/1/0071/9755/6794/files/nz-honey-manuka_1.png"
                    >
                    <img
                      class="desktopImage"
                      src="https://cdn.shopify.com/s/files/1/0071/9755/6794/files/desktop-banner_1.png"
                    >
                  </a>
                </div>`
         );
         console.log("👍 NZ Honey: overlay inserted");
   
         const popupDiv = document.querySelector(".nzHoney_overlaysPopup");
         const cContainer = document.body;
   
         if (popupDiv && cContainer) {
           // g) Smooth transition for scale/box-shadow
           popupDiv.style.transition = "transform 0.5s ease, box-shadow 0.5s ease";
           const bgEls = document.querySelectorAll('.shg-box[data-bgset], div[style*="background-image"]');

   
           // h) On scroll, dim+scale the popup when it's roughly in view
           window.addEventListener("scroll", () => {
             const rect = popupDiv.getBoundingClientRect();
             const topThresh = window.innerHeight * 0.8;
             const botThresh = window.innerHeight * 0.3;
   
             if (rect.top <= topThresh && rect.bottom >= botThresh) {
               console.log("🔦 NZ Honey: popup in view → dim+scale");
               // cContainer.style.backgroundColor = 'rgba(182, 178, 178, 0.65)';
               document.body.classList.add("nzHoney_blackout");
               popupDiv.style.transform = "scale(1.01)";
               bgEls.forEach(el => {
                el.style.setProperty('background-size',  'contain', 'important');
                el.style.setProperty('background-repeat','no-repeat','important');
              });
             } else {
               console.log("🔅 NZ Honey: popup out of view → reset");
               popupDiv.style.transform = "scale(1)";
               popupDiv.style.boxShadow = "";
               // cContainer.style.backgroundColor = '';
               document.body.classList.remove("nzHoney_blackout");
               bgEls.forEach(el => {
                el.style.setProperty('background-size',  'cover', 'important');
                el.style.setProperty('background-repeat','no-repeat','important');
              });
             }
           });
         } else {
           console.error(
             "❌ NZ Honey: popupDiv or container missing",
             popupDiv,
             cContainer
           );
         }
       } catch (err) {
         console.error("❌ NZ Honey: error in popup logic:", err);
       }
     };
   
     initPopup();
    }

    runinlayPopup();
   